module.exports = {
    all:{
        'application': '活動申請',
        'Pleaseenjoy': '請根據活動條件填寫您能享受贈送的金額',
        'Fillamount': '填寫申請金額（非必填）',
        'Applynow': '立即申請',

        'howtoplay': '玩法',
        'playContent': '內容',
    },
    header: {
        'home': '首頁',
        'boardgame': '棋牌遊戲',
        'electronicgames': '電子遊藝',
        'livevideo': '真人視訊',
        'eSportsbattle': '電競對戰',
        'lotterybetting': '彩票投注',
        'sportingevents': '體育賽事',
        'Promotions': '優惠活動',
        'Entitybrand': '實體品牌',
        'onlinebrand': '線上品牌',
        'specialized': '專業博彩運營平台',
        'Proxylogin': '代理登錄',
        'Regularlicense': '正規牌照',
        'borrow': '借唄',
        'YueBao': '餘額寶',
        'Login': '登錄',
        'register': '註冊',
        'Signout': '登出',
        'nohaveTost': '近期上線，敬請期待！ ',
        'Notmember': '還不是會員？ ',
        'review': '審核狀態查看',
        'Alloffers': '全部優惠',
    },
    
    foot: {
        'contactus': '聯繫我們',
        'Strive': '竭力為您提供優質服務',
        'hAgentome': '代理加盟',
        'Let': '讓我們攜手共創美好未來',
        'Join': '加盟諮詢',
        'security': '安全保障',
        'Professional': '專業博彩運營平台',
        'Gaming': '博彩牌照',
        'Hold': '持有 Pagcor 合法執照',
        'View': '立即查看',
        'about': '關於我們',
        'contact': '聯繫方式',
        'Agents': '代理加盟',
        'Disclaimer': '免責聲明',
        'Privacy': '隱私政策',
        'common': '常見問題',
        'game': '博彩責任',
        'All': '版權所有',
        'kefgu': ' 24小時在線客服',
        'actual': ' 真實姓名',
        'real': ' 請輸入您的真實姓名',
        'number': ' 聯繫電話',
        'enterqq': ' 請輸入您的聯繫電話',
        'Reason': ' 申請理由',
        'enter': ' 請輸入您的申請理由',
        'Applications': ' 申請加入',
        'correct': ' 申請輸入正確手機號',
        'enters': ' 請輸入申請理由',
    },

 
    app: {
            'loading': '加載中..',
            'sure': '您確定要退出登錄嗎',
            'hint': '提示',
            'Yes': '是的',
            'No': '點錯了',
            'Linking': '正在鏈接人工客服',
            'Already': '已在當前頁面！ ',
            'Red': '紅包已關閉',
    
            'delete': '請先刪除舊版APP再重新安裝',
            'iOS': 'iOS 用戶請使用 Safari 瀏覽器開啟頁面下載',
            'Scan': '掃碼下載APP',
            'Direct': '無需下載直接訪問',
            'Installation': '安裝教程',
            'Download': '須在同一網絡環境下下載安裝和註冊，勿切換網絡，',
            'cannot': '若無法正常下載，請使用手機瀏覽器開啟。 ',
            'ios1': '1. 掃碼後於頁面中點選【立即下載】',
            'ios2': '2. 點選【允許】',
            'ios3': '3. 點選【關閉】後進入設定',
            'ios4': '4. 點選描述文件安裝',
            'ios5': '5. 點選【安裝】',
            'ios6': '6. 【允許】網站配置描述文件',
            'ios7': '7. 點選【安裝】即可成功安裝、盡情遊玩',
            'adr1': '1. 掃碼後於頁面中點選【立即下載】',
            'adr2': '2【允許】瀏覽器訪問您的設備',
            'adr3': '3. 點選【下載】',
            'adr4': '4. 當下載完成後選擇檔案',
            'adr5': '5. 點選【設置】',
            'adr6': '6. 允許您的設備安裝應用程序',
    
    
        },
        main: {
            'amount': '請輸入操作金額！ ',
            'wallet': '平台錢包',
            'operation': '操作成功！ ',
            'withdrawal': '單筆取款不能低於100元！ ',
            'select': '請選擇您要提現到的銀行卡！ ',
            'enter': '請輸入您的支付密碼！ ',
            'successfully': '提交成功，等待後台審核！ ',
            'address': '請選擇USDT地址!',
            'name': '請輸入存款人姓名!',
            'type': '請輸入銀行類型!',
            'number': '請輸入銀行卡號!',
            'account': '請輸入銀行開戶行地址!',
            'correct': '請輸入正確金額!',
            'Jumping': '正在跳轉...',
            'going': '正在前往頁面',
            'open': '正在前往打開遊戲頁面!',
            'Copy': '複製成功！ ',
            'correctamount': '請輸入正確金額!',
        },
        register: {
            'registerWelcome': '歡迎加入！ ',
            'joinin': '加入',
            'Entertainment': '娛樂平台，擁有獨一無二的會員賬號價值：',
            'maximum1': '1.首存最高可享9999元返現，註冊後即可享受！ ',
            'maximum2': '2、不定期最高返利1元起3.0%，更多棋牌電子優惠等你來拿！ ',
            'maximum3': '3、充值遊戲天天享受：【充值天天送，月返現】！ ',
            'maximum4': '享受業內最豪華的視頻遊戲套餐！ ',
            'maximum5': '詳情請點擊右上角【最新優惠】查看！ ',
            'Signup': '註冊一個帳戶',
            'account': '登錄賬號：',
            'number': '帳號（最少6位，英文及數字）',
            'password': '登錄密碼：',
            'minimumPassword': '密碼（最少8位，英文及數字）',
            'Confirm': '確認密碼：',
            'confirmconfirm': '請確認您的密碼',
            'Member': '會員簡介',
            'actual': '真實姓名：',
            'real': '請輸入您的真實姓名',
            'Withdrawals': '取款密碼：',
            'withdrawal': '請輸入6位取款密碼',
            'code': '驗 證 碼 :',
            'verification': '請輸入您的驗證碼',
            'confirmthat': '我確認所填信息屬實，本人年滿18周歲，已閱讀並接受',
            'Agreement': '相關條款和隱私協議',
            'submit': '提交',
            'havean': '有賬號，',
            'hint': '提示：',
            'bring': '帶',
            'required': '的項目為必填項。 ',
            'proof': '提現密碼是提現金額的證明，請記得填寫密碼。 ',
            'other': '溫馨提示：如果您在註冊過程中遇到同名或無法註冊等其他問題，請聯繫在線客服，我們會盡快為您解決！ ',
            'read': '請閱讀並同意相關條款和隱私協議！ ',
            'Username': '用戶名長度不得低於6位，以字母和數字組合！ ',
            'Password': '密碼長度最少8位！以字母和數字組合！ ',
            'match': '兩次密碼不一致！ ',
            'formatname': '姓名格式不正確，可以是中，英文名稱！ ',
            'length': '支付密碼長度需是6位！ ',
            'codeerror': '驗證碼錯誤！ ',
        },
        login: {
            'tologin': '會員登錄，歡迎登錄！ ',
            'usernameas': '用戶名：',
            'usernameA': '請輸入您的用戶名！ ',
            'passwordS': '密碼：',
            'pleasepassword': '請輸入您的密碼!',
            'verification': '驗證碼',
            'verificationCS': '請輸入驗證碼!',
            'Noaccount': '沒有賬號，',
            'Verificationerror': '驗證碼錯誤！ ',
            'blacklist': '您已被設為黑名單，暫不能登錄，請聯繫管理員！ ',
        'stop': '該用戶已被禁用，請聯繫管理員！ ',
        }
    ,
    index: {
        'Welcome': '歡迎來到',
        'Latest': '最新公告',
        'VIP': 'VIP專屬',
        'Quick': '快速充值',
        'Discount': '優惠大廳',
        'Deposit': '1.2% 存款折扣，3.0% 最高返利',
        'Comprehensive': '綜合遊戲區',
        'beauty': '美女主播',
        'Games': '遊戲和娛樂',
        'Exclusive': '獨家經銷商大收藏',
        'Experience': '體驗歐式美女',
        'players': '20,000 在線玩家',
        'baccarat': '唯一的百家樂',
        'have': '盡情享受歡樂',
        'beautiful': '漂亮的主播',
        'play': '玩新OG',
        'most': '最受歡迎',
        'Classic': '經典玩法',
        'Preferred': '土豪首選',
        'extreme': '極致圖片',
        'surprise': '驚奇',
        'Gamess': '遊戲體驗',
        'visual': '3D視覺盛宴',
        'levels': '更多關卡',
        'rich': '豐富的玩法',
        'high': '高頻彩票',
        'Diversified': '多樣化的玩法',
        'richest': '亞洲最富有的盛會',
        'fast': '快速結算',
        'top': '全球頂級娛樂平台一應俱全',
        'complete': '全網最全的棋牌類游戲，累積獎池1億元，大獎在即！ ',
        'Kaiyuan': '開元棋牌',
        'New': '新世界棋牌',
        'FG': 'FG棋牌',
        'VG': 'VG棋牌',
        'More': '更多',
        'chess': '全網最全的棋牌類游戲，累積獎池1億元，大獎在即！ ',
        'Dynasty': '皇朝電子',
        'HB': 'HB電子',
        'PG': 'PG電子',
        'PP': 'PP電子',
        'Indiana': '奪寶電子',
        'Quality': '品質服務 極致體驗',
        'Authorized': '澳門特別行政區政府授權',
        'Government': '歐洲王國政府授權',
        'Isle': '英國曼島政府授權',
        'Republic': '亞洲菲律賓共和國政府授權',
        'announcement': '公告',
        'official': '★★★官方平台運營商服務商定期，請您對TG入賬款概入賬款我司查看最新入賬！不負責付賬！請給您的每次入賬費用！請查看最新的銀行入賬款。 ',
        'playgames': '玩遊戲',
        'allgames': '所有遊戲',
        'obz': 'OB電子',
        'fgz': 'FG電子',
        'ppz': 'PP電子',
        'aez': 'AE電子',
        'pgz': 'PG電子',
        'fgfish': 'FG捕魚',
        'TFdz': 'TF電競官網是中國專業電競競猜平台商，提供王者榮耀競猜、英雄聯盟競猜、DOTA2競猜、CSGO競猜直播、電競熱門視頻及最新電競資訊等服務。 ',
        'fydz': '汎亞電競是菲律賓產業集團旗下產品，全球競猜系統供應商，提供英雄聯盟，DOTA2，CSGO等電競服務。 ',
        'obdz': 'OB電競，幾萬種電競賽選項；擁有行業領先的競賽成果結算速度。 ',
        'aidz': '每月提供20個電競賽事，2000年，幾萬種電競賽選項；擁有行業領先的競賽成果結算速度。 ',
        'activity': '活動詳情',
        'Event': '活動條款與規則',
        'How': '申請方式',
        'Eligible': '符合條件的會員請於當月申請，逾期則視為放棄！ ',
        'Please': '請在下方填寫您的申請信息',
        'member': '會員賬號',
        'fill': '請正確填寫您的會員賬號',
        'will': '提交後將在30分鐘內為您處理，查看',
        'Audit': '【審核進度】',
        'thanks': '，謝謝！ ',
        'application': '提交申請',
    },
    mine: {
        // 
        'welcome2': '，歡迎',
        'Financial': '金融中心',
        'Loan': '我的貸款',
        'interest': '我的興趣',
        'Center': '會員中心',
        'soon': '即將上線，敬請期待！ ！ ',

        'qihao': '期號',
        'Quota': '配額轉換',
        'transfermode': '轉賬模式',
        'Spin': '免轉模式',
        'refresh': '刷新',
        'recycling': '一鍵回收',
        'Click': '點擊 [刷新] 更新余額數據',
        'Account': '賬戶餘額',
        'balance': '遊戲餘額',
        'titransfert': '轉移方式',
        'transferin': '轉入',
        'transferout': '轉出',
        'Action': '操作金額',
        'Fill': '填寫金額',
        'confirm': '確認',
        'Platform': '平台錢包',
        'operation': '請輸入操作金額！ ',
        'Successful': '操作成功！ ',


        'osit': '存款',
        'Select': '選擇付款方式',
        'Bank': '銀行卡',
        'USDT': 'USDT',
        'Alipay': '支付寶',
        'WeChat': '微信',
        'Manual': '人工充值',
        'Submission': '充值提交',
        'Payment': '支付方式：',
        'information': '收款銀行信息',
        'Payments': '收款賬號：',
        'Copy': '複製',
        'AccountName': '帳戶名稱：',
        'Bankdeposit': '開戶銀行：',
        'BankAddress': '銀行地址：',
        'PaymentInformation': '支付信息',
        'AccountNamea': '帳戶名稱：',

        'SelectBank': '選擇銀行類型',
        'selectsupporting': '請選擇支持銀行',
        'PayerName': '付款人姓名',
        'fillname': '請填寫付款人姓名',
        'Banknumber': '銀行卡號',
        'fillcard': '請填寫付款人銀行卡號',
        'opening': '開戶行地址',
        'address': '請填寫開戶行地址',
        'Recharge': '充值金額',
        'enterwithdrawal': '請輸入取款金額',
        'Submit': '提交',
        'measures': '預防措施',
        'Before': '1. 每次存款前，請到此頁面查看最新收款賬戶。 ',
        'funds': '請勿自行將資金存入舊賬戶。 ',
        'into': '如存入舊賬戶，本公司將無法查核，概不負責。 ',
        'Please2': '2.請盡量在同一家銀行存款。 ',
        'areanother': '如果您在其他銀行，請盡快到賬，以方便系統加快您的入金速度。 ',
        'wallet': '選擇錢包類型',
        'supported': '請選擇支持的錢包類型',
        'arrival': '實際到賬',
        'exchange': '參考匯率：',
        'Human': '人工服務',
        'Contact': '聯繫人工客服',
        'reminder': '溫馨提示',
        'also': '您還未綁定錢包卡片，請前往添加！ ',
        'binding': '前往綁定',
        'enterdepositor': '請輸入存款人姓名',
        'enterbank': '請輸入銀行類型',
        'enterbanks': '請輸入銀行卡號',
        'enteraccount': '請輸入銀行開戶行地址',
        'enteramount': '請輸入金額在',
        'SuccBetweenessful': '之間！ ',
        'Submitted': '提交成功，等待後台審核',
        'Jumping': '正在跳轉...',
        'Copysuccessfully': '複製成功！ ',
        // 取款
        'Withdrawal1': '取款',
        'Addaccount1': '添加賬戶',
        'bankpayment1': '前往綁定銀行卡收款',
        'USDTpayment1': '前往綁定USDT地址收款',
        'Receiving1': '收款賬戶',
        'Receiving12': '請選擇收款賬戶',
        'Accountbalance1': '賬戶餘額',
        'Codesize1': '打碼量',
        'Withdrawalamount1': '取款金額',
        'enterwithdrawal1': '請輸入取款金額',
        'password1': '取款密碼',
        'enterpassword1': '請輸入提現密碼',
        'transaction1': '每筆手續費',
        'USDTconversion1': 'USDT換算',
        'questions1': '如果您有任何問題，請聯繫',
        'Online1': '在線服務',
        'Apply1': '申請提款',
        'measures1': '預防措施',
        'platforms1': '溫馨提示：有餘額的遊戲平台因平台政策因素，可能無法將餘額全部退回主錢包。 ',
        'limit1': '今日取款限額：剩餘99999999.00元/合計99999999.00元今天取款次數：剩餘999999/合計999999取款金額必須大於取款手續費才能取款。 ',
        'supporting1': '請選擇支持銀行',
        'opening1': '填寫開戶行',
        'enteropening1': '請輸入開戶行',
        'cardnumber1': '填寫卡號',
        'cardholder1': '填寫持卡人姓名',
        'Paymentpassword1': '支付密碼',
        'Binding1': '綁定',
        'wallet1': '請選擇錢包協議',
        'USDTaddress1': '填寫USDT地址',
        'enterUSDTaddress1': '請輸入USDT地址',
        'osenterpaymentpasswordit1': '請輸人支付密碼',
        'entername1': '請輸入姓名',
        'enterthebank1': '請輸入銀行',
        'enteraddress1': '請輸入開戶行地址',
        'enterbanknumber1': '請輸人銀行卡號',
        'enterpaymentpassword1': '請輸人支付密碼',
        'correctlength1': '請輸人正確的卡號長度',
        'enterofpassword1': '請輸人支付密碼長度',
        'Bindingsuccessful1': '綁定成功',
        'singlecannot1': '單筆取款不能低於100元',
        'bankwithdrawto1': '請選擇您要提現到的銀行卡',
        'paymentpassword1': '請輸入您的支付密碼',
        'successfullywaiting1': '提交成功，等待後台審核',
        'selectUSDTaddress1': '請選擇USDT地址',
        // 银行卡 钱包管理
        'management': '卡包管理',
        'Managementaa': '管理',
        'Clickbank': '點擊添加銀行卡',
        'ClickUSDT': '點擊添加USDT地址',
        'Unbinding': '解綁',
        'BankName': '銀行名稱',
        'BankHead': '銀行戶主',
        'Accountaddress': '開戶地址',
        'Wallettype': '錢包類型',
        'Walletaddress': '錢包地址',
        'Walletprotocol': '錢包協議',
        'Reminder': '溫馨提示：每個賬戶只能綁定5張銀行卡/USDT錢包，如若修改請刪除後重新添加！ ',
        'Arewant': '確定要解綁嗎？ ',
        'Unbindingsucceeded': '解綁成功',
        

        'Transactionhistory': '交易記錄',
        'BetHistory': '投註記錄',
        'Rebaterecord': '返水記錄',
        'applicationrecord': '活動申請記錄',
        'Proxyapplication': '代理申請',
        'Redenvelope': '紅包',
        'Personalinformation': '個人信息',
        'MessageCenter': '消息中心',
        'Internalmessage': '站內信',
        'Announcement': '公告',


        'Improving2': '改善個人信息可以提高賬戶安全性。真實姓名設置好後只能聯繫客服修改。請認真填寫！ ',
        'Contact2': '聯繫客服',
        'Username2': '用戶名',
        'realname2': '真正的名字',
        'Birthdate2': '出生日期',
        'Mailbox2': '郵箱',
        'Mobilenumber2': '手機號',
        'Confirmation2': '確認',
        'SecurityCenter2': '安全中心',
        'Modifylogin2': '修改登錄密碼',
        'loginbeen2': '登錄密碼已設置，再次設置即可修改登錄密碼',
        'Modify2': '修改',
        'Changesecurity2': '更改安全密碼',
        'securitybeen2': '已設置安全密碼，再次設置可修改安全密碼',
        'alreadyapplied2': '如已申請，請勿重複申請',
        'enteroriginal2': '請輸入原密碼',
        'enternew2': '請輸入新密碼',
        'newenter2': '請重新輸入新密碼',
        'yourname2': '您的姓名',
        'enterreason2': '請輸入申請理由',
        'enterphone2': '請輸入正確手機號',
        'enterapplication2': '請輸入申請理由',
        'enterold2': '請輸入舊密碼',
        'enternewpassword2': '請輸入新密碼',
        'enterpasswordlength2': '請輸入正確的舊密碼長度',
        'entercorrect2': '請輸入正確的新密碼長度',
        'enterconfirmation2': '請輸入確認密碼',
        'passwordstwo2': '兩次密碼不一致！ ',
        'oldnew2': '新舊密碼不能一致！ ',
        'changed2': '密碼修改成功！ ',
        'enterphoneenter2': '請輸入正確手機號',
        'enteremail2': '請輸入正確郵箱號',
        'entercorrect2w': '請輸入正確的日期格式：YYYY-MM-DD',
 
        'platform': '選擇平台',
        'Transactiontype': '交易類型',
        'Selectplatform': '選擇平台',
        'Timerange': '時間範圍',
        'today': '今日',
        'week': '一周內',
        'month': '半月內',
        'onemonth': '一月內',
        'number': '序號',
        'time': '時間',
        'Ordernumber': '訂單號',
        'Transactiontypea': '交易類型',
        'Amount': '金額',
        'Status': '狀態',
        'Nodata': '暫無數據',
        'undefined': '未定義',
        'reviewed': '待審核',
        'Approved': '審核通過',
        'Audit': '審核拒絕',
        'Failed': '失敗',
        'success': '成功',
        'settled': '待結算',
        'platforms': '全平台',
        'Gamename': '遊戲名稱',
        'Payout': '派彩',
        'Invalidbet': '無效注單',
        'Payouts': '已結算',
        'Unpaid': '未結算',


        'Rebatestatus': '返水情況',
        'Accumulatedpayment': '累計領取',
        'Unpaidsdf': '待領取',
        'Received': '已領取',
        'Not': '暫未領取',
        'Receive': '領取',
        'Rebateamount': '返水金額',
        'Rebatetime': '返水時間',
        'Collectiontime': '領取時間',
        'Thereclaim': '暫無領取額度！ ',
        'ApplicationTime': '申請時間',
        'Applycontent': '申請優惠內容',
        'Auditresult': '審核結果',
        

       'Redsituation': '紅包情況',
        'Accumulated': '累計領取次數',
        'Remaining': '剩餘領取次數',
        'Receives': '領取紅包',
        'Redenvelopes': '紅包金額',
        'Rechargetimes': '充值時間',
        'havetrialss': '您的剩餘次數不足！ ',
        'Servererrors': '服務器異常，請稍後再試!',

        'paymentss': '剩餘支付時間',
        'Orderv': '訂單編號',
        'Currentv': '當前匯率',
        'Rechargev': '充值數量',
        'Pleasev': '請注意：您的實際到賬金額要與此金額完全一致，否則無法及時到賬',
        'Pleaseva': '1. 請勿向上述地址充值任何非',
        'Assetva': '資產，否則資產將會丟失；',
        'Pleasevaa': '2. 請務必確認電腦及瀏覽器安全，防止信息被篡改或洩密。 ',
        'Afterv': '2. 向上述地址充值後，需要網絡節點區塊確認，鏈上網絡確認後到賬；',
        'Pleasevas': '3. 請務必確認電腦及瀏覽器安全，防止信息被篡改或洩密。 ',
        'Protocolv': '協議：請使用',
        'TRON': '波場鏈',
        'Ethereum': '以太坊鏈',
        'Protocol': '協議',
        'For': '進行交易 ，其他智能鏈充值造成的不到賬，金額損失自己承擔。 ',
        'Paymentvas': '已完成付款',
        
        
    }
    , vip: {
        'level': 'VIP等級',
        'conditions': '晉級條件',
        'water': '返水比例',
        'running': '累計流水',
        'recharge': '累計充值',

        'CASINO': '真人返水',
        'SLOTS': '電子返水',
        'CARD': '棋牌返水',
        'SPORTS': '體育返水',
        'LOTTERY': '彩票返水',
        'ESPORT': '電競返水',

    },
    Redenvelope:{
        'Remaining': '剩餘領取次數',
        'Received': '已領取',
        'bout': '次',
        'Currently': '當前最多可領取',
        'meet': '快去滿足條件吧！ ',
        'activity': '活動時間',
        'amount': '累計充值金額',
        'Number': '紅包次數',
        'Collection': '領取規則',
        'After': '1.搶到紅包後，系統自動派彩，',
        'Second': '秒到賬',
        'you': '，達到流水倍數即可取款；',
        'Conditions': '2.領取紅包條件：充值金額需要在規定的活動日期（美東時間）範圍內，根據充值累計金額，獲取搶紅包次數，即可搶對應次數的紅包；',
        'Note': '注意：',
        'Grabred': '搶紅包',
        'Beijing': '北京時間為每天早上 10點到12點，存款計算為前一天12點到今天10點，謝謝~',
        'Daily': '每日百萬現金紅包！存款越多，機會越多，紅包享不停，驚喜搶不停，還等什麼？快快叫上好友一起分享吧！ ！ ',
        'Members': '1、會員必須在指定的活動日期（美東時間）範圍內，根據充值累計金額，即可獲得對應搶紅包次數。若在規定的時間範圍內沒有達到存款金額範圍，則不計算搶紅包次數，逾期作廢！ ',
        'All': '2、所有的活動優惠特為玩家而設，如發現任何團體或個人，以不誠實的方式套取紅利或任何威脅、濫用公司優惠等行為，公司保留凍結、取消該團體或個人賬戶及賬戶結餘的權利。 ',
        'rights': '保留所有解釋權，在任何時候都可以更改、停止、取消優惠活動。 ',
        'event': '活動還沒開始，請靜待活動開始。 ',
        'Please': '請靜待下次活動。 ',
        'Congratulations': '恭喜您',
        'Grab': '搶到',
        'meta': '元',
        'Recharge': '立即充值',
        'met': '您暫未達到領取條件，快去完成吧！ ',
        'Server': '服務器異常，請稍後再試',

    }
}


// WEBPACK FOOTER //
// ./src/i18n/tw.js